import {
  ConnectMomentLevelThumbnail,
  ConnectMomentSummaryThumbnail,
} from "@/components/shared/entity-thumbnails";
import { useConnectActivity } from "@/lib/api/activities";
import { isTeenInitiatedConnectConfig } from "@/lib/activities/connect-shapes";
import type { ActivityInteractionThumbnailProps } from "@/lib/activities/registry";
import { useConnectQuestion } from "@/lib/hooks/use-connect-definition";
import { useConversationParticipants } from "@/lib/hooks/conversations/use-conversation-participants";

export function ConnectMomentInteractionThumbnail({
  entityId,
  index,
  context,
}: ActivityInteractionThumbnailProps) {
  const { data: activity } = useConnectActivity(entityId);
  const { mentor, teen } = useConversationParticipants(context);

  const level = (index - 1) as 0 | 1 | 2;
  const questionId =
    index === 0
      ? undefined
      : isTeenInitiatedConnectConfig(activity?.config)
        ? activity?.config.question_ids?.[level]
        : activity?.config.mentor_answers?.[level]?.question_id;
  const question = useConnectQuestion(questionId);

  if (index === 0) {
    return (
      <ConnectMomentSummaryThumbnail
        mentorName={mentor.name ?? "Mentor"}
        mentorAvatarUrl={mentor.avatarUrl}
        teenName={teen.name ?? "Teen"}
        teenAvatarUrl={teen.avatarUrl}
      />
    );
  }

  return (
    <ConnectMomentLevelThumbnail
      level={level}
      questionText={question?.text}
      mentorName={mentor.name ?? "Mentor"}
      mentorAvatarUrl={mentor.avatarUrl}
      teenName={teen.name ?? "Teen"}
      teenAvatarUrl={teen.avatarUrl}
    />
  );
}
